<template>
  <div class="layout c:col-between-stretch">
    <div id="layout-top-teleport"></div>
    <Topbar />
    <div class="layout-main"><router-view></router-view></div>
  </div>
</template>

<script>
import Topbar from "@/components/layout/Topbar.vue";
export default {
  components: { Topbar },
  mounted() {
    console.log("Layout mounted");
  },
};
</script>
<style lang="less">
.layout {
  --layout-header-height: 3rem;
}
</style>
<style lang="less" scoped>
.layout {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #fff;

  #layout-top-teleport {
    width: 100%;
    height: auto;
    margin: 0;
    padding: 0;
    border: none;
  }
}

.layout-main {
  flex: 1;
  width: 100%;
  height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 0;
}
</style>
